/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', function () {
  var sendBtn = document.getElementById('sendbtn');
  if (sendBtn) {
    sendBtn.addEventListener('click', function () {
      alert('click');
      var chcbox = document.getElementById('chcbox');
      if (chcbox && !chcbox.checked) {
        console.log('if');
        alert("Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi'ni okuduğunuza dair kutucuğu işaretlemeniz gerekmektedir.");
        return false;
      }
    });
  }

  /* Product Option Popup */

  document.querySelectorAll('.ProductActions-popup .ProductPopup-elements .popup-element').forEach(function (el) {
    el.addEventListener('click', function () {
      var dataPopup = this.dataset.for;
      console.log(dataPopup);
      document.body.classList.add('mobile-popup-visible');
      var popupBox = document.querySelector(".ProductActions-PopupBox[data-popup='" + dataPopup + "']");
      if (popupBox) popupBox.classList.add('popup-visible');
      document.querySelectorAll('.product-block-list__item .card').forEach(function (card) {
        card.classList.add('bg-overlay');
      });
    });
  });

  document.querySelectorAll('.PopupBox-CloseBtn').forEach(function (el) {
    el.addEventListener('click', function () {
      document.body.classList.remove('mobile-popup-visible');
      document.querySelectorAll('.ProductActions-PopupBox').forEach(function (box) {
        box.classList.remove('popup-visible');
      });
      document.querySelectorAll('.VariantActions-PopupBox').forEach(function (box) {
        box.classList.remove('popup-visible');
      });
      document.querySelectorAll('.product-block-list__item .card').forEach(function (card) {
        card.classList.remove('bg-overlay');
      });
    });
  });
});

/* Product Variant Popup */

// $(".block-swatch-list .product-form__single-selector").click(function(){
  
//   var data_popup = $(this).val().toLowerCase();
//   var data_value = data_popup.replaceAll(' ' , '-');
    
//     console.log(data_value);
//     $("body").addClass("mobile-popup-visible");
//     $(".VariantActions-PopupBox[data-popup='"+data_value+"']").addClass("popup-visible");
//     $(".product-block-list__item .card").addClass("bg-overlay");
// });

